<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '120px'">
          <!-- <el-form-item label="用户id" prop="customerId">
          <el-input v-model="dataForm.customerId" placeholder="用户id"></el-input>
      </el-form-item> -->
      <div class="line-box">
        <el-form-item label="姓名" prop="name" >
          <el-input  v-model="dataForm.name" placeholder="姓名"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
          <el-input  v-model="dataForm.mobile" placeholder="手机号"></el-input>
        </el-form-item>
        <el-form-item label="手机号md5" prop="mobileMd5Value">
          <el-input v-model="dataForm.mobileMd5Value" placeholder="手机号md5值"></el-input>
        </el-form-item>
        <el-form-item  label="产品名称" prop="productId">
          <el-select class="styW1" v-model="dataForm.productId" filterable clearable placeholder="产品名称">
            <el-option
                    v-for="(item,index) in productList"
                    :key="index"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产品对接方式" prop="productDockingMethod">
          <el-select class="styW1" v-model="dataForm.productDockingMethod" filterable clearable placeholder="请选择产品对接方式">
            <el-option
                v-for="item in productMethodList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="渠道名称" prop="channelId">
          <el-select class="styW1" v-model="dataForm.channelId" filterable clearable placeholder="请选择渠道">
            <el-option
                    v-for="item in channels"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属落地页" prop="pageName">
          <el-select class="styW1" v-model="dataForm.pageName" filterable clearable placeholder="请选择落地页">
            <el-option
                    v-for="item in pages"
                    :key="item.value"
                    :label="item.label"
                    :value="item.label">
            </el-option>
          </el-select>
      </el-form-item>
        <el-form-item label="公司名称" prop="companyId">
          <el-select class="styW1" v-model="dataForm.companyId" filterable  clearable placeholder="公司名称">
            <el-option
                    v-for="item in companys"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="星级评分" prop="callType">
          <el-select class="styW1" v-model="dataForm.callType" filterable clearable placeholder="星级评分">
            <el-option
                    v-for="(item,index) in scoreList"
                    :key="index"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否已推送" prop="isPush">
          <el-select class="styW1" v-model="dataForm.isPush" filterable clearable placeholder="是否已推送">
            <el-option
                    v-for="(item,index) in isPushList"
                    :key="index"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select class="styW1" v-model="dataForm.status" filterable clearable placeholder="状态">
            <el-option
                    v-for="(item,index) in statusList"
                    :key="index"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="推送时间" prop="pushDate">
          <el-date-picker
            v-model="dataForm.pushDate"
            type="datetime"
            placeholder="选择日期时间"
            value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
      </div>
         <!-- <el-form-item label="类型" prop="type">
          <el-input v-model="dataForm.type" placeholder="0未回访1有效2无效"></el-input>
        </el-form-item>
        <el-form-item label="进件成功率" prop="companyName">
          <el-input v-model="dataForm.companyName" placeholder="进件成功率"></el-input>
        </el-form-item> -->

          <!-- <el-form-item label="产品ID" prop="productId">
          <el-input v-model="dataForm.productId" placeholder="产品ID"></el-input>
      </el-form-item> -->
          
          
          
      <el-form-item label="推送内容" prop="content">
          <el-input v-model="dataForm.content" placeholder="推送内容"></el-input>
      </el-form-item>
      <el-form-item label="推送返回状态码" prop="pushCode">
          <el-input v-model="dataForm.pushCode" placeholder="推送返回状态码"></el-input>
      </el-form-item>
          <el-form-item label="推送返回信息" prop="pushMsg">
          <el-input v-model="dataForm.pushMsg" placeholder="推送返回信息"></el-input>
      </el-form-item>
          
      <el-form-item label="备注" prop="remark">
          <el-input v-model="dataForm.remark" placeholder="备注"></el-input>
      </el-form-item>
    
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        customerId: '',
        channelId: '',
        productId: '',
        companyId: '',
        mobileMd5Value: '',
        callType: '',
        content: '',
        remark: '',
        isPush: '',
        pushCode: '',
        pushMsg: '',
        pushDate: '',
        creator: '',
        createDate: '',
        updateBy: '',
        updateTime: '',
        deleteTime: '',
        status: '',
        type: '',
        pageName: '',
        channelName: '',
        companyName: '',
        mobile: '',
        name: '',
        productName: '',
        productDockingMethod: ''
      },
      productMethodList:[],
      productList:[],
      channels:[],
      companys:[],
      pages:[],
      scoreList:[],
      isPushList:[
        {
            'label':'否',
            'value':0,
        },
        {
            'label':'是',
            'value':1,
        }
      ],
      statusList:[
        {
            'label':'无效',
            'value':0,
        },
        {
            'label':'有效',
            'value':1,
        }
      ],
    }
  },
  computed: {
    dataRule () {
      return {
        customerId: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        channelId: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        productId: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        companyId: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        mobileMd5Value: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        callType: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        content: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        remark: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        isPush: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        pushCode: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        pushMsg: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        pushDate: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateBy: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateTime: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deleteTime: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        status: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        type: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        pageName: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        channelName: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        companyName: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        mobile: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        name: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        productName: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        productDockingMethod: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.getProductMethods()
    this.getchannelsOptions();
    this.getProductList()
    this.getCompanysOptions();
    this.getPageOptions();
    this.getStarRate()
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    //星级回传列表
    async getStarRate() {
      this.$http.get(`/sys/dict/data/list?dataType=star_rate`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        if (res.data!=null){
          res.data.forEach(element => {
            this.scoreList.push({label:element.dictLabel,value:element.dictValue})
          })
        }
      }).catch(() => {})
    },
    //初始化落地页下拉框中的选项
    async getPageOptions() {
      this.$http.get(`/sys/landingpages/list`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.pages=[];
        if (res.data!=null){
          res.data.forEach(element => {
            this.pages.push({label:element.name,value:element.id})
          })
        }
      }).catch(() => {})
    },
    //初始化产品对接方式
    async getProductMethods() {
      this.$http.get(`/sys/dict/data/list?dataType=productDockingMethod`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        if (res.data!=null){
          res.data.forEach(element => {
            this.productMethodList.push({label:element.dictLabel,value:element.dictValue})
          })
        }
      }).catch(() => {})
    },
     // 产品名称列表
    async getProductList() {
      this.$http.get(`sys/slproduct/page?order=&orderField=&page=1&limit=500`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        if (res.data!=null){
          res.data.list.forEach(element => {
            this.productList.push({label:element.productName,value:element.id})
          })
        }
      }).catch(() => {})
    },
    //初始化渠道下拉框中的选项
    async getchannelsOptions() {
      this.$http.get(`/sys/channels/list`).then(({data: res}) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.channels = [];
        if (res.data != null) {
          res.data.forEach(element => {
            this.channels.push({label: element.name, value: element.id})
          })
        }
      }).catch(() => {
      })
    },
    //初始化公司下拉框中的选项
    async getCompanysOptions() {
      this.$http.get(`/sys/companies/list`).then(({data: res}) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.companys = [];
        if (res.data != null) {
          res.data.forEach(element => {
            this.companys.push({label: element.name, value: element.id,standard: element.standard})
          })
        }
      }).catch(() => {
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/customerscore/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/customerscore/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
<style scoped lang="scss">
  .styW1{
    width: 220px;
  }
</style>
